import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import triangleTypeImg1 from "../../../images/triangle-types-1.png";
import triangleTypeImg2 from "../../../images/triangle-types-2.png";
import median from "../../../images/median.png";
import medianFu from "../../../images/triangle-median-fu.png";
import tringleImg from "../../../images/Regular_triangle.svg.png";
import inradiusImg from "../../../images/inradius.webp";
import circumradiusImg from "../../../images/circumradius.webp";
import { isMobile } from "react-device-detect";
const TITLE = "حاسبة المثلث - أداة لحساب معلومات المثلثات بسهولة";
const DESCRIPTION =
  "استخدم حاسبة المثلث لحساب معلومات المثلثات بسهولة، بما في ذلك أطوال الأضلاع والزوايا والمساحة، مما يسهل عمليات الرسم الهندسي وحل المسائل الرياضية. هذه الحاسبة المثلثية المجانية تقوم بحساب الأضلاع، الزوايا، المساحة، الارتفاع، المحيط، الوسيط، بالإضافة إلى قيم أخرى ورسم تخطيطي للمثلث الناتج.";
const KEYWORDS =
  "حاسبة المثلث, معلومات المثلث, حساب المساحة, حساب الزوايا, حساب الأضلاع, هندسة, رياضيات";
const OG_URL = "https://do-calculate.com/calculator/ar/triangle";
const TriangleCalculator = () => {
  const [angles, setAngles] = useState({ A: "", B: "", C: "" });
  const [sides, setSides] = useState({ a: "", b: "", c: "" });
  const [results, setResults] = useState({});
  const [error, setError] = useState("");
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (["A", "B", "C"].includes(name)) {
      setAngles({ ...angles, [name]: value });
    } else {
      setSides({ ...sides, [name]: value });
    }
  };
  const toRadians = (degrees) => (degrees * Math.PI) / 180;
  const toDegrees = (radians) => (radians * 180) / Math.PI;
  const calculateTriangle = (e) => {
    e.preventDefault();
    let A = parseFloat(angles.A);
    let B = parseFloat(angles.B);
    let C = parseFloat(angles.C);
    let a = parseFloat(sides.a);
    let b = parseFloat(sides.b);
    let c = parseFloat(sides.c);
    let steps = [];
    if (A && B && a) {
      C = 180 - A - B;
      c = (a * Math.sin(toRadians(C))) / Math.sin(toRadians(A));
      b = (a * Math.sin(toRadians(B))) / Math.sin(toRadians(A));
      steps.push(
        `نظرًا لأننا نعرف زاويتين A و B وضلع a، نستخدم قانون الجيب لإيجاد الزاوية C ثم الأضلاع b و c.`
      );
    } else if (A && B && c) {
      C = 180 - A - B;
      a = (c * Math.sin(toRadians(A))) / Math.sin(toRadians(C));
      b = (c * Math.sin(toRadians(B))) / Math.sin(toRadians(C));
      steps.push(
        `نظرًا لأننا نعرف زاويتين A و B وضلع c، نستخدم قانون الجيب لإيجاد الزاوية C ثم الأضلاع a و b.`
      );
    } else if (A && C && a) {
      B = 180 - A - C;
      c = (a * Math.sin(toRadians(C))) / Math.sin(toRadians(A));
      b = (a * Math.sin(toRadians(B))) / Math.sin(toRadians(A));
      steps.push(
        `نظرًا لأننا نعرف زاويتين A و C وضلع a، نستخدم قانون الجيب لإيجاد الزاوية B ثم الأضلاع b و c.`
      );
    } else if (A && C && b) {
      B = 180 - A - C;
      a = (b * Math.sin(toRadians(A))) / Math.sin(toRadians(B));
      c = (b * Math.sin(toRadians(C))) / Math.sin(toRadians(B));
      steps.push(
        `نظرًا لأننا نعرف زاويتين A و C وضلع b، نستخدم قانون الجيب لإيجاد الزاوية B ثم الأضلاع a و c.`
      );
    } else if (B && C && a) {
      A = 180 - B - C;
      b = (a * Math.sin(toRadians(B))) / Math.sin(toRadians(A));
      c = (a * Math.sin(toRadians(C))) / Math.sin(toRadians(A));
      steps.push(
        `نظرًا لأننا نعرف زاويتين B و C وضلع a، نستخدم قانون الجيب لإيجاد الزاوية A ثم الأضلاع b و c.`
      );
    } else if (B && C && b) {
      A = 180 - B - C;
      a = (b * Math.sin(toRadians(A))) / Math.sin(toRadians(B));
      c = (b * Math.sin(toRadians(C))) / Math.sin(toRadians(B));
      steps.push(
        `نظرًا لأننا نعرف زاويتين B و C وضلع b، نستخدم قانون الجيب لإيجاد الزاوية A ثم الأضلاع a و c.`
      );
    }
    else if (a && b && A) {
      B = toDegrees(Math.asin((Math.sin(toRadians(A)) * b) / a));
      C = 180 - A - B;
      c = (Math.sin(toRadians(C)) * a) / Math.sin(toRadians(A));
      steps.push(
        `نظرًا لأننا نعرف الزاوية A والضلعين a و b، نستخدم قانون الجيب لإيجاد الزاوية B ثم الزاوية C والضلع c.`
      );
    } else if (a && c && A) {
      C = toDegrees(Math.asin((Math.sin(toRadians(A)) * c) / a));
      B = 180 - A - C;
      b = (Math.sin(toRadians(B)) * a) / Math.sin(toRadians(A));
      steps.push(
        `نظرًا لأننا نعرف الزاوية A والضلعين a و c، نستخدم قانون الجيب لإيجاد الزاوية C ثم الزاوية B والضلع b.`
      );
    } else if (b && c && B) {
      C = toDegrees(Math.asin((Math.sin(toRadians(B)) * c) / b));
      A = 180 - B - C;
      a = (Math.sin(toRadians(A)) * b) / Math.sin(toRadians(B));
      steps.push(
        `نظرًا لأننا نعرف الزاوية B والضلعين b و c، نستخدم قانون الجيب لإيجاد الزاوية C ثم الزاوية A والضلع a.`
      );
    }
    else if (a && b && c) {
      A = toDegrees(Math.acos((b * b + c * c - a * a) / (2 * b * c)));
      B = toDegrees(Math.acos((a * a + c * c - b * b) / (2 * a * c)));
      C = 180 - A - B;
      steps.push(
        `نظرًا لأننا نعرف الأضلاع الثلاثة a و b و c، نستخدم قانون جيب التمام لإيجاد الزوايا A و B و C.`
      );
    }
    const perimeter = a + b + c;
    const s = perimeter / 2;
    const area = Math.sqrt(s * (s - a) * (s - b) * (s - c));
    const heightA = (2 * area) / a;
    const heightB = (2 * area) / b;
    const heightC = (2 * area) / c;
    const medianA = 0.5 * Math.sqrt(2 * (b * b + c * c) - a * a);
    const medianB = 0.5 * Math.sqrt(2 * (a * a + c * c) - b * b);
    const medianC = 0.5 * Math.sqrt(2 * (a * a + b * b) - c * c);
    const inradius = area / s;
    const circumradius = (a * b * c) / (4 * area);
    steps.push(
      `المساحة: ${area.toFixed(2)}, المحيط: ${perimeter.toFixed(
        2
      )}, ارتفاع A: ${heightA.toFixed(2)}, ارتفاع B: ${heightB.toFixed(
        2
      )}, ارتفاع C: ${heightC.toFixed(
        2
      )}, نصف قطر الدائرة الداخلية: ${inradius.toFixed(
        2
      )}, نصف قطر الدائرة الخارجية: ${circumradius.toFixed(2)}.`
    );
    setResults({
      A,
      B,
      C,
      a,
      b,
      c,
      area,
      perimeter,
      heightA,
      heightB,
      heightC,
      medianA,
      medianB,
      medianC,
      inradius,
      circumradius,
      steps,
    });
  };
  const resetAll = () => {
    setAngles("");
    setResults("");
    setSides("");
    setError("");
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="row">
            <div>
              <p>
                استخدم حاسبة المثلث لحساب معلومات المثلثات بسهولة، بما في ذلك
                أطوال الأضلاع والزوايا والمساحة، مما يسهل عمليات الرسم الهندسي
                وحل المسائل الرياضية. هذه الحاسبة المثلثية المجانية تقوم بحساب
                الأضلاع، الزوايا، المساحة، الارتفاع، المحيط، الوسيط، بالإضافة
                إلى قيم أخرى ورسم تخطيطي للمثلث الناتج.
              </p>
              <hr />
            </div>
            <div className="bg-warning text-black text-center p-2">
              <p>
                يرجى إدخال 3 قيم تتضمن جانباً واحداً على الأقل للحقول الستة
                التالية، ثم انقر على زر "احسب"
              </p>
            </div>
          </div>
          <MobileUnderCalAds />
          <br />
          <div className="row">
            <div className="col-sm-12 col-md-10 calculatorStyle">
              <form>
                <div className="mb-3">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ position: "relative" }}>
                      <img
                        loading="lazy"
                        width="300"
                        height="300"
                        alt="مثلث"
                        src={tringleImg}
                      />
                      <input
                        type="number"
                        name="C"
                        placeholder="الزاوية C"
                        value={angles.C}
                        onChange={handleInputChange}
                        style={{
                          position: "absolute",
                          left: "112px",
                          top: " 5px",
                          width: "80px",
                        }}
                      />
                      <input
                        type="number"
                        name="b"
                        placeholder="الضلع b"
                        value={sides.b}
                        onChange={handleInputChange}
                        style={{
                          position: "absolute",
                          left: "0px",
                          top: " 120px",
                          width: "80px",
                        }}
                      />
                      <input
                        type="number"
                        name="a"
                        placeholder="الضلع a"
                        value={sides.a}
                        onChange={handleInputChange}
                        style={{
                          position: "absolute",
                          right: "0px",
                          top: " 120px",
                          width: "80px",
                        }}
                      />
                      <input
                        type="number"
                        name="B"
                        placeholder="الزاوية B"
                        value={angles.B}
                        onChange={handleInputChange}
                        style={{
                          position: "absolute",
                          right: "-20px",
                          bottom: "5px",
                          width: "80px",
                        }}
                      />
                      <input
                        type="number"
                        name="A"
                        placeholder="الزاوية A"
                        value={angles.A}
                        onChange={handleInputChange}
                        style={{
                          position: "absolute",
                          left: "-20px",
                          bottom: "5px",
                          width: "80px",
                        }}
                      />
                      <input
                        type="number"
                        name="c"
                        placeholder="الضلع c"
                        value={sides.c}
                        onChange={handleInputChange}
                        style={{
                          position: "absolute",
                          left: "112px",
                          bottom: "5px",
                          width: "80px",
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="mb-3 mt-5" style={{ textAlign: "center" }}>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                    onClick={calculateTriangle}
                  >
                    احسب                  </button>
                  <button
                    className="text-white bg-secondary"
                    style={{ fontSize: "20px" }}
                    onClick={resetAll}
                  >
                    امسح النتيجة{" "}
                  </button>
                </div>
              </form>
            </div>
          </div>
          <br />
          { error !== "" && (
            <p className="p-3 mb-2 bg-warning text-black">خطأ: {error}</p>
          )}
          { !error && Object.keys(results).length !== 0 && (
            <div className="row p-3 mb-2 bg-success text-white">
              <h4>النتائج:</h4>
              <hr />
              <div className="col-sm-12 col-md-5">
                <div>
                  <ul>
                    <li>
                      <b> a الضلع</b> = {results.a.toFixed(5)}
                    </li>
                    <li>
                      <b> b الضلع</b> = {results.b.toFixed(5)}
                    </li>
                    <li>
                      <b> c الضلع</b> = {results.c.toFixed(5)}
                    </li>
                    <li>
                      <b> A الزاوية</b> = {results.A.toFixed(5)}°
                    </li>
                    <li>
                      <b> B الزاوية</b> = {results.B.toFixed(5)}°
                    </li>
                    <li>
                      <b> C الزاوية</b> = {results.C.toFixed(5)}°
                    </li>
                    <li>
                      <b>المساحة</b> = {results.area.toFixed(5)}
                    </li>
                    <li>
                      <b>المحيط</b> = {results.perimeter.toFixed(5)}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-sm-12 col-md-5">
                <div>
                  <ul>
                    <li>
                      <b>ha إرتفاع</b> = {results.heightA.toFixed(5)}
                    </li>
                    <li>
                      <b>hb إرتفاع</b> = {results.heightB.toFixed(5)}
                    </li>
                    <li>
                      <b>hc إرتفاع</b> = {results.heightC.toFixed(5)}
                    </li>
                    <li>
                      <b>ma وسيط</b> = {results.medianA.toFixed(5)}
                    </li>
                    <li>
                      <b>mb وسيط</b>= {results.medianB.toFixed(5)}
                    </li>
                    <li>
                      <b>mc وسيط</b> = {results.medianC.toFixed(5)}
                    </li>
                    <li>
                      <b>نصف القطر </b> = {results.inradius.toFixed(5)}
                    </li>
                    <li>
                      <b>دائرة نصف قطره</b> = {results.circumradius.toFixed(5)}
                    </li>
                  </ul>
                </div>
              </div>
              <div
                className="p-3 mb-2 bg-info text-black"
                style={{ width: "100%" }}
              >
                <h4 style={{ color: "black" }}>خطوات الحل:</h4>
                <p style={{ color: "black" }}>{results.steps}</p>
              </div>
            </div>
          )}
          <hr />
          <div className="row">
            <RelatedLinks />
            <hr />
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="col-12 col-md-8">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <u>
                <h3 style={{ fontSize: "16px" }}>ماهو المثلث وأنواعه</h3>
              </u>
            </div>
            <div className="info-section-body">
              <p>
                المثلث هو مضلع له ثلاثة رؤوس. الرأس هو النقطة التي يلتقي فيها
                منحنيان أو خطوط أو حواف أو أكثر؛ في حالة المثلث، يتم ربط القمم
                الثلاثة بثلاثة خطوط تسمى الحواف. عادة ما يشار إلى المثلث برؤوسه.
                ومن ثم، يُشار إلى المثلث ذو الرؤوس a وb وc عادةً بالرمز Δabc.
                علاوة على ذلك، تميل المثلثات إلى وصفها بناءً على طول أضلاعها،
                بالإضافة إلى زواياها الداخلية. على سبيل المثال، المثلث الذي تكون
                فيه أضلاعه الثلاثة متساوية الطول يسمى مثلث متساوي الأضلاع، بينما
                المثلث الذي يكون فيه ضلعان متساويان في الطول يسمى متساوي
                الساقين. عندما لا يكون لأي من أضلاع المثلث أطوال متساوية، يشار
                إليه باسم مختلف الأضلاع، كما هو موضح أدناه.
              </p>
              <div>
                <img
                  loading="lazy"
                  alt="1-انواع المثلث"
                  src={triangleTypeImg1}
                  style={{ width: isMobile ? "250px" : "350px" }}
                />
              </div>
              <p>
                علامات التجزئة الموجودة على حافة المثلث هي علامة شائعة تعكس طول
                الجانب، حيث يعني نفس عدد العلامات طولًا متساويًا. يوجد ترميز
                مماثل للزوايا الداخلية للمثلث، والتي يُشار إليها بأعداد مختلفة
                من الأقواس متحدة المركز الموجودة عند رؤوس المثلث. كما يتبين من
                المثلثات أعلاه، فإن طول المثلث وزواياه الداخلية مرتبطان ارتباطًا
                مباشرًا، لذا فمن المنطقي أن يكون للمثلث متساوي الأضلاع ثلاث
                زوايا داخلية متساوية وثلاثة أضلاع متساوية الطول. لاحظ أن المثلث
                الموجود في الآلة الحاسبة لا يظهر بمقياس الرسم؛ في حين أنه يبدو
                متساوي الأضلاع (ولديه علامات زاوية يمكن قراءتها عادةً على أنها
                متساوية)، إلا أنه ليس بالضرورة متساوي الأضلاع وهو مجرد تمثيل
                لمثلث. عند إدخال القيم الفعلية، ستعكس مخرجات الآلة الحاسبة الشكل
                الذي يجب أن يبدو عليه مثلث الإدخال. تنقسم المثلثات المصنفة بناءً
                على زواياها الداخلية إلى فئتين: قائمة أو مائلة. المثلث القائم هو
                مثلث تكون إحدى زواياه 90 درجة، ويشار إليه بقطعتين مستقيمتين
                تشكلان مربعًا في الرأس يشكل الزاوية القائمة. أطول حافة في المثلث
                القائم، وهي الحافة المقابلة للزاوية القائمة، تسمى الوتر. أي مثلث
                ليس مثلثًا قائمًا يتم تصنيفه على أنه مثلث مائل ويمكن أن يكون
                منفرجًا أو حادًا. في المثلث المنفرج، تكون إحدى زوايا المثلث أكبر
                من 90 درجة، بينما في المثلث الحاد تكون جميع الزوايا أقل من 90
                درجة، كما هو موضح أدناه.
              </p>
              <div>
                <img
                  loading="lazy"
                  alt="2-انواع المثلث"
                  src={triangleTypeImg2}
                  style={{ width: isMobile ? "250px" : "350px" }}
                />
              </div>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <u>
                <h3 style={{ fontSize: "16px" }}>
                  حقائق المثلث والنظريات والقوانين
                </h3>
              </u>
            </div>
            <div className="info-section-body">
              <p>
                - لا يمكن أن يكون للمثلث أكثر من رأس زاوية داخلية أكبر من أو
                تساوي 90 درجة، وإلا فلن يكون مثلثًا.
                <br />- مجموع الزوايا الداخلية للمثلث دائمًا ما يصل إلى 180 درجة
                بينما الزوايا الخارجية للمثلث تساوي مجموع الزاويتين الداخليتين
                غير المجاورتين له. هناك طريقة أخرى لحساب الزاوية الخارجية للمثلث
                وهي طرح زاوية الرأس محل الاهتمام من 180 درجة.
                <br />- مجموع طولي أي ضلعين في المثلث يكون دائمًا أكبر من طول
                الضلع الثالث.
                <br />- نظرية فيثاغورس: نظرية فيثاغورس هي نظرية خاصة بالمثلثات
                القائمة. في أي مثلث قائم الزاوية، مربع طول الوتر يساوي مجموع
                مربعي طولي الضلعين الآخرين. ويترتب على ذلك أن أي مثلث تتوفر فيه
                أضلاعه هذا الشرط هو مثلث قائم الزاوية. هناك أيضًا حالات خاصة
                للمثلثات القائمة، مثل 30° 60° 90، 45° 45° 90°، و3 4 5 مثلثات
                قائمة تسهل العمليات الحسابية. حيث a و b ضلعان للمثلث، و c هو
                الوتر، يمكن كتابة نظرية فيثاغورس على النحو التالي:
              </p>
              <p>
                <strong>
                  a<sup>2</sup> + b<sup>2</sup> = c<sup>2</sup>
                </strong>
              </p>
              <p>
                - قانون الجيب: النسبة بين طول ضلع المثلث وجيب الزاوية المقابلة
                له ثابتة. إن استخدام قانون الجيب يجعل من الممكن العثور على زوايا
                وجوانب مجهولة للمثلث بمعلومات كافية. عندما تكون الجوانب أ، ب، ج،
                والزوايا أ، ب، ج كما هو موضح في الآلة الحاسبة أعلاه، يمكن كتابة
                قانون الجيب كما هو موضح أدناه. وبالتالي، إذا كانت b وB وC
                معروفة، فمن الممكن العثور على c من خلال ربط b/sin(B) وc/sin(C).
                لاحظ أن هناك حالات عندما يستوفي المثلث شروطًا معينة، حيث يكون من
                الممكن وجود تكوينين مختلفين للمثلث في ضوء نفس مجموعة البيانات.
              </p>
              <strong>(a/sin(A))=(b/sin(B))=(c/sin(C))</strong>
              <p>
                - بمعرفة أطوال الأضلاع الثلاثة لأي مثلث، يمكن حساب كل زاوية
                باستخدام المعادلة التالية. ارجع إلى المثلث أعلاه، بافتراض أن a
                وb وc هي قيم معروفة.
              </p>
              <strong>
                A = arccos((b<sup>2</sup> + c<sup>2</sup> - a<sup>2</sup>)/2bc)
              </strong>
              <br />
              <strong>
                B = arccos((a<sup>2</sup> + c<sup>2</sup> - b<sup>2</sup>)/2ac)
              </strong>
              <br />
              <strong>
                C = arccos((a<sup>2</sup> + b<sup>2</sup> - c<sup>2</sup>)/2ab)
              </strong>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <u>
                <h3 style={{ fontSize: "16px" }}>مساحة المثلث</h3>
              </u>
            </div>
            <div className="info-section-body">
              <p>
                - هناك عدة معادلات مختلفة لحساب مساحة المثلث، اعتمادًا على
                المعلومات المعروفة. من المحتمل أن المعادلة الأكثر شيوعًا لحساب
                مساحة المثلث تتضمن قاعدته b وارتفاعه h. تشير "القاعدة" إلى أي
                ضلع من أضلاع المثلث حيث يمثل الارتفاع بطول القطعة المستقيمة
                المرسومة من الرأس المقابل للقاعدة، إلى نقطة على القاعدة تكون
                متعامدة.
              </p>
              <p>
                <strong>area = (1/2) × b × h</strong>
              </p>
              <p>
                - بمعرفة طول الضلعين والزاوية بينهما، يمكن استخدام الصيغة
                التالية لتحديد مساحة المثلث. لاحظ أن المتغيرات المستخدمة تشير
                إلى المثلث الموضح في الآلة الحاسبة أعلاه.
              </p>
              <strong>area = (1/2) × ab × sin(C)</strong>
              <strong> = (1/2) × bc × sin(A)</strong>
              <strong> = (1/2) × ac × sin(B)</strong>
              <p>
                - هناك طريقة أخرى لحساب مساحة المثلث تستخدم صيغة هيرون. على عكس
                المعادلات السابقة، لا تتطلب صيغة هيرون اختيارًا عشوائيًا لجانب
                كقاعدة أو قمة كنقطة أصل. لكن يشترط معرفة أطوال الأضلاع الثلاثة.
                مرة أخرى، في إشارة إلى المثلث الموجود في الآلة الحاسبة
              </p>
              <strong>area = √s(s - a)(s - b)(s - c)</strong>
              <br /> <strong>Where: s = (a + b + c)/2</strong>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <u>
                <h3 style={{ fontSize: "16px" }}>الوسيط</h3>
              </u>
            </div>
            <div className="info-section-body">
              <p>
                يتم تعريف متوسط ​​المثلث على أنه طول القطعة المستقيمة التي تمتد
                من قمة المثلث إلى منتصف الجانب المقابل. يمكن أن يحتوي المثلث على
                ثلاثة متوسطات، تتقاطع جميعها عند المركز الأوسط (موضع المتوسط
                الحسابي لجميع النقاط في المثلث) للمثلث. الرجوع إلى الشكل
                الوارد أدناه للتوضيح.
              </p>
              <div>
                <img
                  loading="lazy"
                  alt="الوسيط"
                  src={median}
                  style={{ width: isMobile ? "250px" : "350px" }}
                />
              </div>
              <p>
                يتم تمثيل متوسطات المثلث بواسطة المقاطع الخطية ma وmb وmc. ويمكن
                حساب طول كل وسيط على النحو التالي:
              </p>
              <img loading="lazy" alt="معادلة الوسيط" src={medianFu} />
              <p>حيث تمثل a وb وc طول ضلع المثلث كما هو موضح في الشكل أعلاه.</p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <u>
                <h3 style={{ fontSize: "16px" }}>نصف القطر</h3>
              </u>
            </div>
            <div className="info-section-body">
              <p>
                نصف القطر هو نصف قطر أكبر دائرة يمكن وضعها داخل المضلع المحدد،
                وهو في هذه الحالة مثلث. نصف القطر متعامد على كل جانب من جوانب
                المضلع. في المثلث، يمكن تحديد نصف القطر من خلال إنشاء منصفين
                للزاوية لتحديد مركز المثلث. نصف القطر هو المسافة العمودية بين
                مركز المثلث وأحد أضلاعه. يمكن استخدام أي جانب من أضلاع المثلث
                طالما تم تحديد المسافة العمودية بين الضلع والمركز، حيث أن
                المركز، بحكم التعريف، متساوي البعد من كل جانب من جوانب المثلث
              </p>
              <div>
                <img
                  loading="lazy"
                  alt="نصف القطر"
                  src={inradiusImg}
                  style={{ width: isMobile ? "250px" : "250px" }}
                />
              </div>
              <p>
                لأغراض هذه الآلة الحاسبة، يتم حساب نصف القطر باستخدام المساحة
                (المساحة) وشبه محيط المثلث بالإضافة إلى الصيغ التالية:
              </p>
              <strong>inradius = area/s</strong>
              <br />
              <strong>s = (a + b +c)/2</strong>
              <br />
              <p>حيث a، b، c هي أضلاع المثلث</p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <u>
                <h3 style={{ fontSize: "16px" }}>دائرة نصف قطرها</h3>
              </u>
            </div>
            <div className="info-section-body">
              <p>
                يتم تعريف محيط القطر على أنه نصف قطر الدائرة التي تمر بجميع رؤوس
                المضلع، وهو في هذه الحالة مثلث. ومركز هذه الدائرة، حيث تلتقي
                جميع المنصفات المتعامدة من كل ضلع من أضلاع المثلث، هو محيط
                المثلث، وهو النقطة التي يقاس منها محيط نصف القطر. ليس من الضروري
                أن يكون محيط المثلث داخل المثلث. ومن الجدير بالذكر أن جميع
                المثلثات لها دائرة محيطية (الدائرة التي تمر عبر كل قمة)،
                وبالتالي محيط نصف القطر.
              </p>
              <div>
                <img
                  loading="lazy"
                  alt="دائرة نصف قطر المثلث"
                  src={circumradiusImg}
                  style={{ width: isMobile ? "150px" : "150px" }}
                />
              </div>
              <p>
                لأغراض هذه الآلة الحاسبة، يتم حساب نصف القطر باستخدام الصيغة
                التالية:
              </p>
              <strong>circumradius = a/2sin(A)</strong>
              <p>
                حيث a أحد أضلاع المثلث، و A هي الزاوية المقابلة للضلع a <br />{" "}
                على الرغم من استخدام الضلع a والزاوية A، إلا أنه يمكن استخدام أي
                من الجوانب والزوايا المقابلة لها في الصيغة.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default TriangleCalculator;
